const settlementsData = [
    {
     "key": 1,
     "value": "Bjelovar",
     "jls": "Bjelovar"
    },
    {
     "key": 2,
     "value": "Breza",
     "jls": "Bjelovar"
    },
    {
     "key": 3,
     "value": "Brezovac",
     "jls": "Bjelovar"
    },
    {
     "key": 4,
     "value": "Ciglena",
     "jls": "Bjelovar"
    },
    {
     "key": 5,
     "value": "Galovac",
     "jls": "Bjelovar"
    },
    {
     "key": 6,
     "value": "Gornje Plavnice",
     "jls": "Bjelovar"
    },
    {
     "key": 7,
     "value": "Gornji Tomaš",
     "jls": "Bjelovar"
    },
    {
     "key": 8,
     "value": "Gudovac",
     "jls": "Bjelovar"
    },
    {
     "key": 9,
     "value": "Klokočevac",
     "jls": "Bjelovar"
    },
    {
     "key": 10,
     "value": "Kokinac",
     "jls": "Bjelovar"
    },
    {
     "key": 11,
     "value": "Kupinovac",
     "jls": "Bjelovar"
    },
    {
     "key": 12,
     "value": "Letičani",
     "jls": "Bjelovar"
    },
    {
     "key": 13,
     "value": "Mala Ciglena",
     "jls": "Bjelovar"
    },
    {
     "key": 14,
     "value": "Malo Korenovo",
     "jls": "Bjelovar"
    },
    {
     "key": 15,
     "value": "Novi Pavljani",
     "jls": "Bjelovar"
    },
    {
     "key": 16,
     "value": "Novoseljani",
     "jls": "Bjelovar"
    },
    {
     "key": 17,
     "value": "Obrovnica",
     "jls": "Bjelovar"
    },
    {
     "key": 18,
     "value": "Patkovac",
     "jls": "Bjelovar"
    },
    {
     "key": 19,
     "value": "Prespa",
     "jls": "Bjelovar"
    },
    {
     "key": 20,
     "value": "Prgomelje",
     "jls": "Bjelovar"
    },
    {
     "key": 21,
     "value": "Prokljuvani",
     "jls": "Bjelovar"
    },
    {
     "key": 22,
     "value": "Puričani",
     "jls": "Bjelovar"
    },
    {
     "key": 23,
     "value": "Rajić",
     "jls": "Bjelovar"
    },
    {
     "key": 24,
     "value": "Stančići",
     "jls": "Bjelovar"
    },
    {
     "key": 25,
     "value": "Stare Plavnice",
     "jls": "Bjelovar"
    },
    {
     "key": 26,
     "value": "Stari Pavljani",
     "jls": "Bjelovar"
    },
    {
     "key": 27,
     "value": "Tomaš",
     "jls": "Bjelovar"
    },
    {
     "key": 28,
     "value": "Trojstveni Markovac",
     "jls": "Bjelovar"
    },
    {
     "key": 29,
     "value": "Veliko Korenovo",
     "jls": "Bjelovar"
    },
    {
     "key": 30,
     "value": "Zvijerci",
     "jls": "Bjelovar"
    },
    {
     "key": 31,
     "value": "Ždralovi",
     "jls": "Bjelovar"
    },
    {
     "key": 32,
     "value": "Andigola",
     "jls": "Čazma"
    },
    {
     "key": 33,
     "value": "Bojana",
     "jls": "Čazma"
    },
    {
     "key": 34,
     "value": "Bosiljevo",
     "jls": "Čazma"
    },
    {
     "key": 35,
     "value": "Cerina",
     "jls": "Čazma"
    },
    {
     "key": 36,
     "value": "Čazma",
     "jls": "Čazma"
    },
    {
     "key": 37,
     "value": "Dapci",
     "jls": "Čazma"
    },
    {
     "key": 38,
     "value": "Dereza",
     "jls": "Čazma"
    },
    {
     "key": 39,
     "value": "Donji Draganec",
     "jls": "Čazma"
    },
    {
     "key": 40,
     "value": "Donji Dragičevci",
     "jls": "Čazma"
    },
    {
     "key": 41,
     "value": "Donji Lipovčani",
     "jls": "Čazma"
    },
    {
     "key": 42,
     "value": "Donji Miklouš",
     "jls": "Čazma"
    },
    {
     "key": 43,
     "value": "Gornji Draganec",
     "jls": "Čazma"
    },
    {
     "key": 44,
     "value": "Gornji Dragičevci",
     "jls": "Čazma"
    },
    {
     "key": 45,
     "value": "Gornji Lipovčani",
     "jls": "Čazma"
    },
    {
     "key": 46,
     "value": "Gornji Miklouš",
     "jls": "Čazma"
    },
    {
     "key": 47,
     "value": "Grabik",
     "jls": "Čazma"
    },
    {
     "key": 48,
     "value": "Grabovnica",
     "jls": "Čazma"
    },
    {
     "key": 49,
     "value": "Komuševac",
     "jls": "Čazma"
    },
    {
     "key": 50,
     "value": "Marčani",
     "jls": "Čazma"
    },
    {
     "key": 51,
     "value": "Martinac",
     "jls": "Čazma"
    },
    {
     "key": 52,
     "value": "Milaševac",
     "jls": "Čazma"
    },
    {
     "key": 53,
     "value": "Novo Selo",
     "jls": "Čazma"
    },
    {
     "key": 54,
     "value": "Općevac",
     "jls": "Čazma"
    },
    {
     "key": 55,
     "value": "Palančani",
     "jls": "Čazma"
    },
    {
     "key": 56,
     "value": "Pavličani",
     "jls": "Čazma"
    },
    {
     "key": 57,
     "value": "Pobjenik",
     "jls": "Čazma"
    },
    {
     "key": 58,
     "value": "Pobrđani",
     "jls": "Čazma"
    },
    {
     "key": 59,
     "value": "Prnjarovac",
     "jls": "Čazma"
    },
    {
     "key": 60,
     "value": "Prokljuvani",
     "jls": "Čazma"
    },
    {
     "key": 61,
     "value": "Sišćani",
     "jls": "Čazma"
    },
    {
     "key": 62,
     "value": "Sovari",
     "jls": "Čazma"
    },
    {
     "key": 63,
     "value": "Suhaja",
     "jls": "Čazma"
    },
    {
     "key": 64,
     "value": "Vagovina",
     "jls": "Čazma"
    },
    {
     "key": 65,
     "value": "Vrtlinska",
     "jls": "Čazma"
    },
    {
     "key": 66,
     "value": "Vučani",
     "jls": "Čazma"
    },
    {
     "key": 67,
     "value": "Zdenčec",
     "jls": "Čazma"
    },
    {
     "key": 68,
     "value": "Daruvar",
     "jls": "Daruvar"
    },
    {
     "key": 69,
     "value": "Daruvarski Vinogradi",
     "jls": "Daruvar"
    },
    {
     "key": 70,
     "value": "Doljani",
     "jls": "Daruvar"
    },
    {
     "key": 71,
     "value": "Donji Daruvar",
     "jls": "Daruvar"
    },
    {
     "key": 72,
     "value": "Gornji Daruvar",
     "jls": "Daruvar"
    },
    {
     "key": 73,
     "value": "Lipovac Majur",
     "jls": "Daruvar"
    },
    {
     "key": 74,
     "value": "Ljudevit Selo",
     "jls": "Daruvar"
    },
    {
     "key": 75,
     "value": "Markovac",
     "jls": "Daruvar"
    },
    {
     "key": 76,
     "value": "Vrbovac",
     "jls": "Daruvar"
    },
    {
     "key": 77,
     "value": "Ciglenica",
     "jls": "Garešnica"
    },
    {
     "key": 78,
     "value": "Dišnik",
     "jls": "Garešnica"
    },
    {
     "key": 79,
     "value": "Duhovi",
     "jls": "Garešnica"
    },
    {
     "key": 80,
     "value": "Garešnica",
     "jls": "Garešnica"
    },
    {
     "key": 81,
     "value": "Garešnički Brestovac",
     "jls": "Garešnica"
    },
    {
     "key": 82,
     "value": "Gornji Uljanik",
     "jls": "Garešnica"
    },
    {
     "key": 83,
     "value": "Hrastovac",
     "jls": "Garešnica"
    },
    {
     "key": 84,
     "value": "Kajgana",
     "jls": "Garešnica"
    },
    {
     "key": 85,
     "value": "Kaniška Iva",
     "jls": "Garešnica"
    },
    {
     "key": 86,
     "value": "Kapelica",
     "jls": "Garešnica"
    },
    {
     "key": 87,
     "value": "Mala Bršljanica",
     "jls": "Garešnica"
    },
    {
     "key": 88,
     "value": "Mali Pašijan",
     "jls": "Garešnica"
    },
    {
     "key": 89,
     "value": "Malo Vukovje",
     "jls": "Garešnica"
    },
    {
     "key": 90,
     "value": "Rogoža",
     "jls": "Garešnica"
    },
    {
     "key": 91,
     "value": "Tomašica",
     "jls": "Garešnica"
    },
    {
     "key": 92,
     "value": "Trnovitički Popovac",
     "jls": "Garešnica"
    },
    {
     "key": 93,
     "value": "Uljanički Brijeg",
     "jls": "Garešnica"
    },
    {
     "key": 94,
     "value": "Uljanik",
     "jls": "Garešnica"
    },
    {
     "key": 95,
     "value": "Velika Bršljanica",
     "jls": "Garešnica"
    },
    {
     "key": 96,
     "value": "Veliki Pašijan",
     "jls": "Garešnica"
    },
    {
     "key": 97,
     "value": "Veliki Prokop",
     "jls": "Garešnica"
    },
    {
     "key": 98,
     "value": "Veliko Vukovje",
     "jls": "Garešnica"
    },
    {
     "key": 99,
     "value": "Zdenčac",
     "jls": "Garešnica"
    },
    {
     "key": 100,
     "value": "Dapčevački Brđani",
     "jls": "Grubišno Polje"
    },
    {
     "key": 101,
     "value": "Dijakovac",
     "jls": "Grubišno Polje"
    },
    {
     "key": 102,
     "value": "Donja Rašenica",
     "jls": "Grubišno Polje"
    },
    {
     "key": 103,
     "value": "Gornja Rašenica",
     "jls": "Grubišno Polje"
    },
    {
     "key": 104,
     "value": "Grbavac",
     "jls": "Grubišno Polje"
    },
    {
     "key": 105,
     "value": "Grubišno Polje",
     "jls": "Grubišno Polje"
    },
    {
     "key": 106,
     "value": "Ivanovo Selo",
     "jls": "Grubišno Polje"
    },
    {
     "key": 107,
     "value": "Lončarica",
     "jls": "Grubišno Polje"
    },
    {
     "key": 108,
     "value": "Mala Barna",
     "jls": "Grubišno Polje"
    },
    {
     "key": 109,
     "value": "Mala Dapčevica",
     "jls": "Grubišno Polje"
    },
    {
     "key": 110,
     "value": "Mala Jasenovača",
     "jls": "Grubišno Polje"
    },
    {
     "key": 111,
     "value": "Mala Peratovica",
     "jls": "Grubišno Polje"
    },
    {
     "key": 112,
     "value": "Mali Zdenci",
     "jls": "Grubišno Polje"
    },
    {
     "key": 113,
     "value": "Munije",
     "jls": "Grubišno Polje"
    },
    {
     "key": 114,
     "value": "Orlovac Zdenački",
     "jls": "Grubišno Polje"
    },
    {
     "key": 115,
     "value": "Poljani",
     "jls": "Grubišno Polje"
    },
    {
     "key": 116,
     "value": "Rastovac",
     "jls": "Grubišno Polje"
    },
    {
     "key": 117,
     "value": "Treglava",
     "jls": "Grubišno Polje"
    },
    {
     "key": 118,
     "value": "Turčević Polje",
     "jls": "Grubišno Polje"
    },
    {
     "key": 119,
     "value": "Velika Barna",
     "jls": "Grubišno Polje"
    },
    {
     "key": 120,
     "value": "Velika Dapčevica",
     "jls": "Grubišno Polje"
    },
    {
     "key": 121,
     "value": "Velika Jasenovača",
     "jls": "Grubišno Polje"
    },
    {
     "key": 122,
     "value": "Velika Peratovica",
     "jls": "Grubišno Polje"
    },
    {
     "key": 123,
     "value": "Veliki Zdenci",
     "jls": "Grubišno Polje"
    },
    {
     "key": 124,
     "value": "Begovača",
     "jls": "Berek"
    },
    {
     "key": 125,
     "value": "Berek",
     "jls": "Berek"
    },
    {
     "key": 126,
     "value": "Gornja Garešnica",
     "jls": "Berek"
    },
    {
     "key": 127,
     "value": "Kostanjevac",
     "jls": "Berek"
    },
    {
     "key": 128,
     "value": "Krivaja",
     "jls": "Berek"
    },
    {
     "key": 129,
     "value": "Novo Selo Garešničko",
     "jls": "Berek"
    },
    {
     "key": 130,
     "value": "Oštri Zid",
     "jls": "Berek"
    },
    {
     "key": 131,
     "value": "Podgarić",
     "jls": "Berek"
    },
    {
     "key": 132,
     "value": "Potok",
     "jls": "Berek"
    },
    {
     "key": 133,
     "value": "Ruškovac",
     "jls": "Berek"
    },
    {
     "key": 134,
     "value": "Šimljana",
     "jls": "Berek"
    },
    {
     "key": 135,
     "value": "Šimljanica",
     "jls": "Berek"
    },
    {
     "key": 136,
     "value": "Šimljanik",
     "jls": "Berek"
    },
    {
     "key": 137,
     "value": "Blagorodovac",
     "jls": "Dežanovac"
    },
    {
     "key": 138,
     "value": "Dežanovac",
     "jls": "Dežanovac"
    },
    {
     "key": 139,
     "value": "Donji Sređani",
     "jls": "Dežanovac"
    },
    {
     "key": 140,
     "value": "Drlež",
     "jls": "Dežanovac"
    },
    {
     "key": 141,
     "value": "Golubinjak",
     "jls": "Dežanovac"
    },
    {
     "key": 142,
     "value": "Gornji Sređani",
     "jls": "Dežanovac"
    },
    {
     "key": 143,
     "value": "Goveđe Polje",
     "jls": "Dežanovac"
    },
    {
     "key": 144,
     "value": "Ivanovo Polje",
     "jls": "Dežanovac"
    },
    {
     "key": 145,
     "value": "Kaštel Dežanovački",
     "jls": "Dežanovac"
    },
    {
     "key": 146,
     "value": "Kreštelovac",
     "jls": "Dežanovac"
    },
    {
     "key": 147,
     "value": "Sokolovac",
     "jls": "Dežanovac"
    },
    {
     "key": 148,
     "value": "Trojeglava",
     "jls": "Dežanovac"
    },
    {
     "key": 149,
     "value": "Bastajski Brđani",
     "jls": "Đulovac"
    },
    {
     "key": 150,
     "value": "Batinjani",
     "jls": "Đulovac"
    },
    {
     "key": 151,
     "value": "Batinjska Rijeka",
     "jls": "Đulovac"
    },
    {
     "key": 152,
     "value": "Borova Kosa",
     "jls": "Đulovac"
    },
    {
     "key": 153,
     "value": "Dobra Kuća",
     "jls": "Đulovac"
    },
    {
     "key": 154,
     "value": "Donja Vrijeska",
     "jls": "Đulovac"
    },
    {
     "key": 155,
     "value": "Donje Cjepidlake",
     "jls": "Đulovac"
    },
    {
     "key": 156,
     "value": "Đulovac",
     "jls": "Đulovac"
    },
    {
     "key": 157,
     "value": "Gornja Vrijeska",
     "jls": "Đulovac"
    },
    {
     "key": 158,
     "value": "Gornje Cjepidlake",
     "jls": "Đulovac"
    },
    {
     "key": 159,
     "value": "Katinac",
     "jls": "Đulovac"
    },
    {
     "key": 160,
     "value": "Koreničani",
     "jls": "Đulovac"
    },
    {
     "key": 161,
     "value": "Kravljak",
     "jls": "Đulovac"
    },
    {
     "key": 162,
     "value": "Mala Babina Gora",
     "jls": "Đulovac"
    },
    {
     "key": 163,
     "value": "Mala Klisa",
     "jls": "Đulovac"
    },
    {
     "key": 164,
     "value": "Mali Bastaji",
     "jls": "Đulovac"
    },
    {
     "key": 165,
     "value": "Mali Miletinac",
     "jls": "Đulovac"
    },
    {
     "key": 166,
     "value": "Maslenjača",
     "jls": "Đulovac"
    },
    {
     "key": 167,
     "value": "Nova Krivaja",
     "jls": "Đulovac"
    },
    {
     "key": 168,
     "value": "Potočani",
     "jls": "Đulovac"
    },
    {
     "key": 169,
     "value": "Puklica",
     "jls": "Đulovac"
    },
    {
     "key": 170,
     "value": "Removac",
     "jls": "Đulovac"
    },
    {
     "key": 171,
     "value": "Stara Krivaja",
     "jls": "Đulovac"
    },
    {
     "key": 172,
     "value": "Škodinovac",
     "jls": "Đulovac"
    },
    {
     "key": 173,
     "value": "Velika Babina Gora",
     "jls": "Đulovac"
    },
    {
     "key": 174,
     "value": "Velika Klisa",
     "jls": "Đulovac"
    },
    {
     "key": 175,
     "value": "Veliki Bastaji",
     "jls": "Đulovac"
    },
    {
     "key": 176,
     "value": "Veliki Miletinac",
     "jls": "Đulovac"
    },
    {
     "key": 177,
     "value": "Vukovije",
     "jls": "Đulovac"
    },
    {
     "key": 178,
     "value": "Hercegovac",
     "jls": "Hercegovac"
    },
    {
     "key": 179,
     "value": "Ilovski Klokočevac",
     "jls": "Hercegovac"
    },
    {
     "key": 180,
     "value": "Ladislav",
     "jls": "Hercegovac"
    },
    {
     "key": 181,
     "value": "Palešnik",
     "jls": "Hercegovac"
    },
    {
     "key": 182,
     "value": "Velika Trnava",
     "jls": "Hercegovac"
    },
    {
     "key": 183,
     "value": "Babinac",
     "jls": "Ivanska"
    },
    {
     "key": 184,
     "value": "Donja Petrička",
     "jls": "Ivanska"
    },
    {
     "key": 185,
     "value": "Đurđic",
     "jls": "Ivanska"
    },
    {
     "key": 186,
     "value": "Gornja Petrička",
     "jls": "Ivanska"
    },
    {
     "key": 187,
     "value": "Ivanska",
     "jls": "Ivanska"
    },
    {
     "key": 188,
     "value": "Kolarevo Selo",
     "jls": "Ivanska"
    },
    {
     "key": 189,
     "value": "Križic",
     "jls": "Ivanska"
    },
    {
     "key": 190,
     "value": "Paljevine",
     "jls": "Ivanska"
    },
    {
     "key": 191,
     "value": "Rastovac",
     "jls": "Ivanska"
    },
    {
     "key": 192,
     "value": "Samarica",
     "jls": "Ivanska"
    },
    {
     "key": 193,
     "value": "Srijedska",
     "jls": "Ivanska"
    },
    {
     "key": 194,
     "value": "Stara Plošćica",
     "jls": "Ivanska"
    },
    {
     "key": 195,
     "value": "Utiskani",
     "jls": "Ivanska"
    },
    {
     "key": 196,
     "value": "Babotok",
     "jls": "Kapela"
    },
    {
     "key": 197,
     "value": "Botinac",
     "jls": "Kapela"
    },
    {
     "key": 198,
     "value": "Donji Mosti",
     "jls": "Kapela"
    },
    {
     "key": 199,
     "value": "Gornje Zdelice",
     "jls": "Kapela"
    },
    {
     "key": 200,
     "value": "Gornji Mosti",
     "jls": "Kapela"
    },
    {
     "key": 201,
     "value": "Jabučeta",
     "jls": "Kapela"
    },
    {
     "key": 202,
     "value": "Kapela",
     "jls": "Kapela"
    },
    {
     "key": 203,
     "value": "Kobasičari",
     "jls": "Kapela"
    },
    {
     "key": 204,
     "value": "Lalići",
     "jls": "Kapela"
    },
    {
     "key": 205,
     "value": "Lipovo Brdo",
     "jls": "Kapela"
    },
    {
     "key": 206,
     "value": "Nova Diklenica",
     "jls": "Kapela"
    },
    {
     "key": 207,
     "value": "Novi Skucani",
     "jls": "Kapela"
    },
    {
     "key": 208,
     "value": "Pavlin Kloštar",
     "jls": "Kapela"
    },
    {
     "key": 209,
     "value": "Poljančani",
     "jls": "Kapela"
    },
    {
     "key": 210,
     "value": "Prnjavor",
     "jls": "Kapela"
    },
    {
     "key": 211,
     "value": "Reškovci",
     "jls": "Kapela"
    },
    {
     "key": 212,
     "value": "Sredice Gornje",
     "jls": "Kapela"
    },
    {
     "key": 213,
     "value": "Srednja Diklenica",
     "jls": "Kapela"
    },
    {
     "key": 214,
     "value": "Srednji Mosti",
     "jls": "Kapela"
    },
    {
     "key": 215,
     "value": "Stanići",
     "jls": "Kapela"
    },
    {
     "key": 216,
     "value": "Stara Diklenica",
     "jls": "Kapela"
    },
    {
     "key": 217,
     "value": "Starčevljani",
     "jls": "Kapela"
    },
    {
     "key": 218,
     "value": "Stari Skucani",
     "jls": "Kapela"
    },
    {
     "key": 219,
     "value": "Šiptari",
     "jls": "Kapela"
    },
    {
     "key": 220,
     "value": "Tvrda Reka",
     "jls": "Kapela"
    },
    {
     "key": 221,
     "value": "Visovi",
     "jls": "Kapela"
    },
    {
     "key": 222,
     "value": "Boriš",
     "jls": "Končanica"
    },
    {
     "key": 223,
     "value": "Brestovačka Brda",
     "jls": "Končanica"
    },
    {
     "key": 224,
     "value": "Daruvarski Brestovac",
     "jls": "Končanica"
    },
    {
     "key": 225,
     "value": "Dioš",
     "jls": "Končanica"
    },
    {
     "key": 226,
     "value": "Imsovac",
     "jls": "Končanica"
    },
    {
     "key": 227,
     "value": "Končanica",
     "jls": "Končanica"
    },
    {
     "key": 228,
     "value": "Otkopi",
     "jls": "Končanica"
    },
    {
     "key": 229,
     "value": "Stražanac",
     "jls": "Končanica"
    },
    {
     "key": 230,
     "value": "Šuplja Lipa",
     "jls": "Končanica"
    },
    {
     "key": 231,
     "value": "Bedenik",
     "jls": "Nova Rača"
    },
    {
     "key": 232,
     "value": "Bulinac",
     "jls": "Nova Rača"
    },
    {
     "key": 233,
     "value": "Dautan",
     "jls": "Nova Rača"
    },
    {
     "key": 234,
     "value": "Drljanovac",
     "jls": "Nova Rača"
    },
    {
     "key": 235,
     "value": "Kozarevac Račanski",
     "jls": "Nova Rača"
    },
    {
     "key": 236,
     "value": "Međurača",
     "jls": "Nova Rača"
    },
    {
     "key": 237,
     "value": "Nevinac",
     "jls": "Nova Rača"
    },
    {
     "key": 238,
     "value": "Nova Rača",
     "jls": "Nova Rača"
    },
    {
     "key": 239,
     "value": "Orlovac",
     "jls": "Nova Rača"
    },
    {
     "key": 240,
     "value": "Sasovac",
     "jls": "Nova Rača"
    },
    {
     "key": 241,
     "value": "Slovinska Kovačica",
     "jls": "Nova Rača"
    },
    {
     "key": 242,
     "value": "Stara Rača",
     "jls": "Nova Rača"
    },
    {
     "key": 243,
     "value": "Tociljevac",
     "jls": "Nova Rača"
    },
    {
     "key": 244,
     "value": "Domankuš",
     "jls": "Rovišće"
    },
    {
     "key": 245,
     "value": "Gornje Rovišće",
     "jls": "Rovišće"
    },
    {
     "key": 246,
     "value": "Kakinac",
     "jls": "Rovišće"
    },
    {
     "key": 247,
     "value": "Kovačevac",
     "jls": "Rovišće"
    },
    {
     "key": 248,
     "value": "Kraljevac",
     "jls": "Rovišće"
    },
    {
     "key": 249,
     "value": "Lipovčani",
     "jls": "Rovišće"
    },
    {
     "key": 250,
     "value": "Podgorci",
     "jls": "Rovišće"
    },
    {
     "key": 251,
     "value": "Predavac",
     "jls": "Rovišće"
    },
    {
     "key": 252,
     "value": "Prekobrdo",
     "jls": "Rovišće"
    },
    {
     "key": 253,
     "value": "Rovišće",
     "jls": "Rovišće"
    },
    {
     "key": 254,
     "value": "Tuk",
     "jls": "Rovišće"
    },
    {
     "key": 255,
     "value": "Žabjak",
     "jls": "Rovišće"
    },
    {
     "key": 256,
     "value": "Orovac",
     "jls": "Severin"
    },
    {
     "key": 257,
     "value": "Severin",
     "jls": "Severin"
    },
    {
     "key": 258,
     "value": "Barica",
     "jls": "Sirač"
    },
    {
     "key": 259,
     "value": "Bijela",
     "jls": "Sirač"
    },
    {
     "key": 260,
     "value": "Donji Borki",
     "jls": "Sirač"
    },
    {
     "key": 261,
     "value": "Gornji Borki",
     "jls": "Sirač"
    },
    {
     "key": 262,
     "value": "Kip",
     "jls": "Sirač"
    },
    {
     "key": 263,
     "value": "Miljanovac",
     "jls": "Sirač"
    },
    {
     "key": 264,
     "value": "Pakrani",
     "jls": "Sirač"
    },
    {
     "key": 265,
     "value": "Sirač",
     "jls": "Sirač"
    },
    {
     "key": 266,
     "value": "Šibovac",
     "jls": "Sirač"
    },
    {
     "key": 267,
     "value": "Jasenik",
     "jls": "Šandrovac"
    },
    {
     "key": 268,
     "value": "Kašljavac",
     "jls": "Šandrovac"
    },
    {
     "key": 269,
     "value": "Lasovac",
     "jls": "Šandrovac"
    },
    {
     "key": 270,
     "value": "Lasovac Brdo",
     "jls": "Šandrovac"
    },
    {
     "key": 271,
     "value": "Pupelica",
     "jls": "Šandrovac"
    },
    {
     "key": 272,
     "value": "Ravneš",
     "jls": "Šandrovac"
    },
    {
     "key": 273,
     "value": "Šandrovac",
     "jls": "Šandrovac"
    },
    {
     "key": 274,
     "value": "Blatnica",
     "jls": "Štefanje"
    },
    {
     "key": 275,
     "value": "Daskatica",
     "jls": "Štefanje"
    },
    {
     "key": 276,
     "value": "Donja Šušnjara",
     "jls": "Štefanje"
    },
    {
     "key": 277,
     "value": "Gornja Šušnjara",
     "jls": "Štefanje"
    },
    {
     "key": 278,
     "value": "Laminac",
     "jls": "Štefanje"
    },
    {
     "key": 279,
     "value": "Narta",
     "jls": "Štefanje"
    },
    {
     "key": 280,
     "value": "Starine",
     "jls": "Štefanje"
    },
    {
     "key": 281,
     "value": "Staro Štefanje",
     "jls": "Štefanje"
    },
    {
     "key": 282,
     "value": "Štefanje",
     "jls": "Štefanje"
    },
    {
     "key": 283,
     "value": "Babinac",
     "jls": "Velika Pisanica"
    },
    {
     "key": 284,
     "value": "Bačkovica",
     "jls": "Velika Pisanica"
    },
    {
     "key": 285,
     "value": "Bedenička",
     "jls": "Velika Pisanica"
    },
    {
     "key": 286,
     "value": "Čađavac",
     "jls": "Velika Pisanica"
    },
    {
     "key": 287,
     "value": "Nova Pisanica",
     "jls": "Velika Pisanica"
    },
    {
     "key": 288,
     "value": "Polum",
     "jls": "Velika Pisanica"
    },
    {
     "key": 289,
     "value": "Ribnjačka",
     "jls": "Velika Pisanica"
    },
    {
     "key": 290,
     "value": "Velika Pisanica",
     "jls": "Velika Pisanica"
    },
    {
     "key": 291,
     "value": "Gornja Ploščica",
     "jls": "Velika Trnovitica"
    },
    {
     "key": 292,
     "value": "Gornja Trnovitica",
     "jls": "Velika Trnovitica"
    },
    {
     "key": 293,
     "value": "Mala Mlinska",
     "jls": "Velika Trnovitica"
    },
    {
     "key": 294,
     "value": "Mala Trnovitica",
     "jls": "Velika Trnovitica"
    },
    {
     "key": 295,
     "value": "Mlinski Vinogradi",
     "jls": "Velika Trnovitica"
    },
    {
     "key": 296,
     "value": "Nova Ploščica",
     "jls": "Velika Trnovitica"
    },
    {
     "key": 297,
     "value": "Velika Mlinska",
     "jls": "Velika Trnovitica"
    },
    {
     "key": 298,
     "value": "Velika Trnovitica",
     "jls": "Velika Trnovitica"
    },
    {
     "key": 299,
     "value": "Cremušina",
     "jls": "Veliki Grđevac"
    },
    {
     "key": 300,
     "value": "Donja Kovačica",
     "jls": "Veliki Grđevac"
    },
    {
     "key": 301,
     "value": "Dražica",
     "jls": "Veliki Grđevac"
    },
    {
     "key": 302,
     "value": "Gornja Kovačica",
     "jls": "Veliki Grđevac"
    },
    {
     "key": 303,
     "value": "Mala Pisanica",
     "jls": "Veliki Grđevac"
    },
    {
     "key": 304,
     "value": "Mali Grđevac",
     "jls": "Veliki Grđevac"
    },
    {
     "key": 305,
     "value": "Pavlovac",
     "jls": "Veliki Grđevac"
    },
    {
     "key": 306,
     "value": "Sibenik",
     "jls": "Veliki Grđevac"
    },
    {
     "key": 307,
     "value": "Topolovica",
     "jls": "Veliki Grđevac"
    },
    {
     "key": 308,
     "value": "Veliki Grđevac",
     "jls": "Veliki Grđevac"
    },
    {
     "key": 309,
     "value": "Zrinska",
     "jls": "Veliki Grđevac"
    },
    {
     "key": 310,
     "value": "Ćurlovac",
     "jls": "Veliko Trojstvo"
    },
    {
     "key": 311,
     "value": "Dominkovica",
     "jls": "Veliko Trojstvo"
    },
    {
     "key": 312,
     "value": "Grginac",
     "jls": "Veliko Trojstvo"
    },
    {
     "key": 313,
     "value": "Kegljevac",
     "jls": "Veliko Trojstvo"
    },
    {
     "key": 314,
     "value": "Maglenča",
     "jls": "Veliko Trojstvo"
    },
    {
     "key": 315,
     "value": "Malo Trojstvo",
     "jls": "Veliko Trojstvo"
    },
    {
     "key": 316,
     "value": "Martinac",
     "jls": "Veliko Trojstvo"
    },
    {
     "key": 317,
     "value": "Paulovac",
     "jls": "Veliko Trojstvo"
    },
    {
     "key": 318,
     "value": "Veliko Trojstvo",
     "jls": "Veliko Trojstvo"
    },
    {
     "key": 319,
     "value": "Višnjevac",
     "jls": "Veliko Trojstvo"
    },
    {
     "key": 320,
     "value": "Vrbica",
     "jls": "Veliko Trojstvo"
    },
    {
     "key": 321,
     "value": "Jakopovac",
     "jls": "Zrinski Topolovac"
    },
    {
     "key": 322,
     "value": "Križ Gornji",
     "jls": "Zrinski Topolovac"
    },
    {
     "key": 323,
     "value": "Zrinski Topolovac",
     "jls": "Zrinski Topolovac"
    }
   ]
export default settlementsData;
